import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";

import Divider from "@material-ui/core/Divider";

const styles = theme => ({
		image: {
			height: "40px",
			width: "auto"
		},
		textContainer:{
			width: '100%',
			margin: '0px 15px',
			'& span:nth-child(2)':{
				float: 'right',
			}
		}
	}
);

function StatProgress(props) {
	const { name, img, classes, isLast, text } = props;
	return (
		<div>
			<ListItem >
				<img className={classes.image} src={img} alt={name} />
				<div className={classes.textContainer}>
					<span>{text}</span>
				</div>

			</ListItem>
			{isLast || <Divider variant="inset" />}
		</div>
	);
}

StatProgress.propTypes = {
	name: PropTypes.string.isRequired,
	img: PropTypes.string.isRequired,
	isLast: PropTypes.bool,
	text: PropTypes.object.isRequired,

	classes: PropTypes.shape({
		image: PropTypes.string.isRequired,
		textContainer: PropTypes.string.isRequired,
	}).isRequired,
};

export default withStyles(styles)(StatProgress);
